import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function TermosUso() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-lg shadow-sm p-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-8">Termos de Uso</h1>
            
            <div className="prose prose-lg max-w-none">
              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-900 mb-3">1. Introdução</h4>
                <p className="text-gray-700 mb-6">
                  Bem-vindo ao site da <em>7deOuros</em>. Ao acessar e utilizar nosso site, você concorda em cumprir e estar vinculado aos seguintes Termos de Uso. Se você não concorda com qualquer parte destes termos, por favor, não utilize nosso site.
                </p>
              </div>

              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-900 mb-3">2. Uso do Site</h4>
                <p className="text-gray-700 mb-6">
                  Você concorda em utilizar o site da <em>7deOuros</em> apenas para fins legais e de maneira que não infrinja os direitos de terceiros, nem restrinja ou iniba o uso e aproveitamento do site por terceiros. Atividades proibidas incluem, mas não se limitam a, assédio ou causar angústia ou inconveniência a qualquer pessoa, transmissão de conteúdo obsceno ou ofensivo, ou interrupção do fluxo normal de diálogo dentro do site.
                </p>
              </div>

              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-900 mb-3">3. Propriedade Intelectual</h4>
                <p className="text-gray-700 mb-6">
                  Todo o conteúdo presente no site, incluindo, mas não se limitando a, textos, gráficos, logotipos, ícones, imagens, clipes de áudio, downloads digitais e compilações de dados, é de propriedade da <em>7deOuros</em> ou de seus fornecedores de conteúdo e é protegido por leis de direitos autorais e outras leis de propriedade intelectual. Você não pode reproduzir, duplicar, copiar, vender, revender ou explorar qualquer parte do site sem a permissão expressa por escrito da <em>7deOuros</em>.
                </p>
              </div>

              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-900 mb-3">4. Links para Sites de Terceiros</h4>
                <p className="text-gray-700 mb-6">
                  Nosso site pode conter links para sites de terceiros que não são operados pela <em>7deOuros</em>. Esses links são fornecidos apenas para sua conveniência e não implicam em qualquer endosso ou associação com os operadores desses sites. Não temos controle sobre o conteúdo, políticas de privacidade ou práticas de sites de terceiros e não assumimos qualquer responsabilidade por eles.
                </p>
              </div>

              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-900 mb-3">5. Limitação de Responsabilidade</h4>
                <p className="text-gray-700 mb-6">
                  A <em>7deOuros</em> não será responsável por quaisquer danos diretos, indiretos, incidentais, consequenciais ou punitivos decorrentes do uso ou da incapacidade de usar este site, mesmo que a <em>7deOuros</em> tenha sido avisada da possibilidade de tais danos. Isso inclui, sem limitação, danos por perda de lucros, uso, dados ou outras perdas intangíveis.
                </p>
              </div>

              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-900 mb-3">6. Alterações nos Termos de Uso</h4>
                <p className="text-gray-700 mb-6">
                  A <em>7deOuros</em> reserva-se o direito de modificar estes Termos de Uso a qualquer momento. Quaisquer alterações serão publicadas nesta página com a data de revisão atualizada. É sua responsabilidade revisar estes Termos de Uso periodicamente para estar ciente de quaisquer alterações. Seu uso continuado do site após a publicação de alterações constitui sua aceitação dos Termos de Uso modificados.
                </p>
              </div>

              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-900 mb-3">7. Privacidade</h4>
                <p className="text-gray-700 mb-6">
                  O uso do site da <em>7deOuros</em> também é regido por nossa <a href="/politica-privacidade" className="text-red-600 hover:text-red-800 underline">Política de Privacidade</a>, que descreve como coletamos, usamos e protegemos suas informações pessoais.
                </p>
              </div>

              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-900 mb-3">8. Lei Aplicável</h4>
                <p className="text-gray-700 mb-6">
                  Estes Termos de Uso são regidos e interpretados de acordo com as leis do Brasil, sem considerar seus conflitos de princípios legais. Você concorda que qualquer disputa decorrente ou relacionada a estes Termos de Uso será resolvida exclusivamente nos tribunais localizados em Maringá, Paraná.
                </p>
              </div>

              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-900 mb-3">9. Contato</h4>
                <p className="text-gray-700 mb-3">
                  Se você tiver dúvidas ou preocupações sobre estes Termos de Uso, entre em contato conosco:
                </p>
                <ul className="list-disc pl-6 text-gray-700 mb-6">
                  <li>Telefone: (44) 98804-7699</li>
                  <li>E-mail: contato@setedeouros.com.br</li>
                </ul>
              </div>

              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-900 mb-3">10. Data de Vigência</h4>
                <p className="text-gray-700 mb-6">
                  Estes Termos de Uso são vigentes a partir de 12 de julho de 2024.
                </p>
              </div>

              <div className="pt-6 border-t border-gray-200">
                <p className="text-gray-700">
                  7deOuros<br />
                  São Paulo – SP<br />
                  © 2025 7deOuros. Todos os direitos reservados.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}